import { OPTIONAL } from './../../constants/constant';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { checkHTMLTags } from '../../validators/textPatternValidator';

@Component({
  selector: 'app-input-textarea',
  templateUrl: './input-textarea.component.html',
  styleUrls: ['./input-textarea.component.scss', '../input-textbox/input-textbox.component.scss']
})
export class InputTextareaComponent implements OnInit, OnDestroy {

  @Input() labelName: string;
  @Input() showLabelName = true;
  @Input() disableComments = false;
  @Input() inputFormControl: FormControl;
  @Input() placeHolder = "Input Field Text";
  @Input() submitted = false;
  @Input() readOnlyMode = false;
  @Input() showCommentIcon = false;
  @Input() commentObject: FormControl;
  @Input() tooltiptxt: string;
  @Input() labelTextTransformNone = false;
  @Input() showOptionalLabel = true;
  @Output() onShowComment = new EventEmitter();

  OPTIONAL = OPTIONAL;

  constructor() { }

  ngOnInit(): void {
    if (this.inputFormControl && this.inputFormControl.validator) {
      this.inputFormControl.setValidators([this.inputFormControl.validator, checkHTMLTags()]);
    } else {
      this.inputFormControl.setValidators([checkHTMLTags()]);
    }
    this.inputFormControl.valueChanges.subscribe((value) => {
      if (value && (value.length === 1) && (value === ' ')) {
        this.inputFormControl.setValue(null, { emitEvent: false });
      }
    });
  }

  get isRequiredField(): boolean {
    if (!this.inputFormControl.validator) {
      return false;
    }

    const validator = this.inputFormControl.validator({} as AbstractControl);
    return (validator && validator.required);
  }

  getClasses(): string {
    if (this.inputFormControl &&
      (this.submitted || this.inputFormControl.touched) &&
      this.inputFormControl.errors) {
      if (this.showCommentIcon) {
        return 'error-input show-comment-input';
      }
      return 'error-input';
    } else {
      if (this.showCommentIcon) {
        return 'show-comment-input';
      }
      return '';
    }
  }

  public clickComment(): void {
    this.onShowComment.emit();
  }

  ngOnDestroy(): void {
  }
}
